import { Ionicons } from "@/src/components/ui/ionicons";
import { ActivityIndicator, Pressable, StyleSheet, Text, View } from "react-native";

import { BrandIntro } from "@/src/components/brand/BrandIntro";
import { action, radius, spacing, surface, text, typography } from "@/src/theme/tokens";

type Props =
  | { mode: "loading"; offline?: never; onRetry?: never }
  | { mode: "error"; offline: boolean; onRetry: () => void };

export function StartupStateScreen(props: Props) {
  if (props.mode === "loading") {
    return (
      <View accessibilityLabel="Chargement de Neqraw" accessibilityLiveRegion="polite" style={styles.screen}>
        <BrandIntro compact />
        <View style={styles.loadingRow}>
          <ActivityIndicator color={action.primary} size="small" />
          <Text style={styles.loadingText}>Préparation de ton espace…</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.screen}>
      <BrandIntro compact />
      <View style={styles.message}>
        <View style={styles.iconContainer}>
          <Ionicons accessible={false} color={text.brand} name={props.offline ? "cloud-offline-outline" : "refresh-outline"} size={28} />
        </View>
        <Text style={styles.heading}>{props.offline ? "Connexion indisponible" : "Profil indisponible"}</Text>
        <Text style={styles.body}>
          {props.offline
            ? "Vérifie ta connexion internet puis réessaie. Ton profil n’a pas été modifié."
            : "Le profil n’a pas pu être chargé. Réessaie dans quelques instants. Ton profil n’a pas été modifié."}
        </Text>
      </View>
      <Pressable
        accessibilityRole="button"
        onPress={props.onRetry}
        style={({ pressed }) => [styles.retry, pressed && styles.retryPressed]}
      >
        <Text style={styles.retryText}>Réessayer</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    alignItems: "center",
    backgroundColor: surface.secondary,
    flex: 1,
    gap: spacing.xxl,
    justifyContent: "center",
    padding: spacing.xl,
  },
  loadingRow: { alignItems: "center", flexDirection: "row", gap: spacing.md },
  loadingText: { color: text.secondary, fontFamily: typography.family.regular, fontSize: 15, lineHeight: 22 },
  message: { alignItems: "center", gap: spacing.md, maxWidth: 420 },
  iconContainer: { alignItems: "center", backgroundColor: surface.selected, borderRadius: radius.lg, height: 56, justifyContent: "center", width: 56 },
  heading: { color: text.primary, fontFamily: typography.family.semibold, fontSize: typography.size.title, lineHeight: typography.lineHeight.title, textAlign: "center" },
  body: { color: text.secondary, fontFamily: typography.family.regular, fontSize: typography.size.body, lineHeight: typography.lineHeight.body, textAlign: "center" },
  retry: { alignItems: "center", backgroundColor: action.primary, borderRadius: radius.md, justifyContent: "center", minHeight: 52, minWidth: 150, paddingHorizontal: spacing.xl },
  retryPressed: { backgroundColor: action.primaryPressed },
  retryText: { color: text.inverse, fontFamily: typography.family.semibold, fontSize: typography.size.body },
});
